<template>
    <div>
        <div class="p-grid">
            <app-menu-bar title="Monitoring Daftar Dokumen Pengadaan" back_url="monitoring_pimpinan.dashboard" />
            <div class="p-col-12">
                <div class="card">
                    <div v-if="isUnitScoped" class="mb-4 p-3 bg-blue-100 border-round">
                        <i class="pi pi-info-circle mr-2"></i>
                        <span>Menampilkan data untuk unit Anda</span>
                    </div>
                    
                    <DataTable ref="dt" :value="datatable.data" :lazy="true" data-key="id" :paginator="true" :rows="10"
                        :loading="datatable.loading" :total-records="datatable.totalRecords" filter-display="menu"
                        :global-filter-fields="datatable.globalFilterFields" v-model:filters="datatable.filters"
                        paginator-template="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        :rows-per-page-options="[5, 10, 25]"
                        current-page-report-template="Menampilkan data ke {first} sampai {last} dari total {totalRecords} data"
                        @page="onPage($event)" @sort="onSort($event)" @filter="onFilter()">
                        <template #header>
                            <div class="table-header">
                                <div class="flex justify-content-between">
                                    <Button type="button" icon="pi pi-filter-slash" label="Clear"
                                        class="p-button-outlined" @click="clearFilter()" />
                                    <span class="p-input-icon-left">
                                        <i class="pi pi-search" />
                                        <InputText v-model="datatable.filters['global'].value"
                                            @keydown.enter="onFilter()" placeholder="Keyword Search" />
                                    </span>
                                </div>
                            </div>
                        </template>
                        <Column field="isi_doc" header="Keterangan Dokumen">
                            <template #body="slotProps">
                                {{ slotProps.data.isi_doc }}<br>
                            </template>
                        </Column>
                        <Column field="status" header="Status">
                            <template #body="slotProps">
                                <span :class="getStatusClass(slotProps.data.status)">
                                    {{ slotProps.data.status }}
                                </span>
                            </template>
                        </Column>
                        <Column header="Aksi" style="width: 150px;">
                            <template #body="slotProps">
                                <Button icon="pi pi-eye" label="Lihat Detail"
                                    class="p-button-info p-button-sm mr-1" 
                                    @click="viewDetail(slotProps.data)" />
                            </template>
                        </Column>
                        <template #empty>
                            Belum ada Data!
                        </template>
                    </DataTable>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import AppLayout from "../../Layouts/AppLayout";
import AppMenuBar from "../../Components/AppMenuBar.vue";
import DataTable from "primevue/datatable";
import { FilterMatchMode } from "primevue/api";
import DatatableService from "../../Services/DatatableService";
import Menubar from "primevue/menubar";
import ProgressBar from "primevue/progressbar";
import Column from "primevue/column";
import Button from "primevue/button";
import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import { Link } from '@inertiajs/inertia-vue3';

export default {
    name: "MonitoringPimpinanList",
    layout: AppLayout,
    components: {
        AppLayout,
        AppMenuBar,
        Menubar,
        DataTable,
        Column,
        Button,
        Toolbar,
        Link,
        InputText,
        Dialog,
        ProgressBar,
    },
    props: {
        prosedur_id: String,
        kode_tahap: String,
        status: String,
        isUnitScoped: Boolean,
    },
    data() {
        return {
            datatable: {
                prosedur_id: this.prosedur_id,
                kode_tahap: this.kode_tahap,
                status: this.status,
                loading: true,
                totalRecords: 0,
                data: null,
                globalFilterFields: ['isi_doc'],
                filters: {
                    'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                },
                lazyParams: {}
            },
        }
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
    },
    async mounted() {
        this.datatable.loading = true;
        this.datatable.lazyParams = {
            prosedur_id: this.prosedur_id,
            kode_tahap: this.kode_tahap,
            status: this.status,
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: 'id',
            sortOrder: -1,
            filters: this.datatable.filters,
            globalFilterFields: this.datatable.globalFilterFields
        };
        this.loadLazyData();
    },
    methods: {
        async loadLazyData() {
            this.datatable.loading = true;
            
            this.datatableService.getData(this.route('monitoring_pimpinan.datatable'), {
                dt_params: JSON.stringify(this.datatable.lazyParams),
                searchable_columns: JSON.stringify(this.datatable.globalFilterFields)
            }).then(data => {
                this.datatable.data = data.payload.data;
                this.datatable.totalRecords = data.payload.total;
                this.datatable.loading = false;
            }).catch(error => {
                this.datatable.loading = false;
                this.datatable.data = [];
                this.datatable.totalRecords = 0;
            });
        },
        onFilter() {
            this.datatable.lazyParams.filters = this.datatable.filters;
            this.loadLazyData();
        },
        clearFilter() {
            this.datatable.filters = {
                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            };
            this.datatable.lazyParams.filters = this.datatable.filters;
            this.loadLazyData();
        },
        onPage(event) {
            this.datatable.lazyParams = event;
            this.loadLazyData();
        },
        onSort(event) {
            this.datatable.lazyParams = event;
            this.loadLazyData();
        },
        viewDetail(data) {
            this.$inertia.visit(this.route('monitoring_pimpinan.summary', { id: data.id }));
        },
        getStatusClass(status) {
            const statusClasses = {
                'proses': 'text-blue-600 font-semibold',
                'selesai': 'text-green-600 font-semibold',
                'direvisi': 'text-purple-600 font-semibold',
                'revisi': 'text-orange-600 font-semibold',
                'batal': 'text-red-600 font-semibold',
            };
            return statusClasses[status] || 'text-gray-600';
        }
    }
}
</script>

<style scoped></style>
